export default __webpack_public_path__ + "static/media/Asset 13.c8548208.svg";